module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAkCAYAAABBszIzAAAAAXNSR0IArs4c6QAAAKJJREFUeF7t2FERACAMw9Dh3wsWxx028nAwko+2Z+7ueNkfOATIsv+HE6DNnwBx/gQggBCYdkAGSOMXAuP4CUAAO0DbARmgzV8NjPMnAAHsAGkHZIA0fjUwjp8ABLADtB2QAdr81cA4fwIQwA6QdkAGSONXA+P4CUAAO0DbARmgzV8NjPMnAAHsAGkHZIA0fjUwjp8ABLADtB2QAdr81cA4/3kHf2BVZoVWnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_eyes/nav_click.png
// module id = o6MJ
// module chunks = 2